import { Link } from "react-router-dom";
import { Radio, Mail, BookOpen } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] text-[#F5F0E8]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#C5A059] flex items-center justify-center">
                <Radio size={16} className="text-[#0A1628]" />
              </div>
              <span className="font-serif text-[#F5F0E8] font-bold tracking-wide text-sm uppercase">
                Donald Inbody
              </span>
            </div>
            <p className="text-[#F5F0E8]/60 text-sm leading-relaxed">
              Author, political scientist, naval historian, amateur radio operator (ADØK), and musician with BuffaloGrass.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-[#C5A059] font-semibold mb-4 text-sm uppercase tracking-widest">
              Navigation
            </h4>
            <ul className="space-y-2">
              {[
                { label: "About", path: "/about" },
                { label: "Books & Research", path: "/books" },
                { label: "Captain's Log", path: "/blog" },
                { label: "Radio (ADØK)", path: "/ad0k" },
                { label: "Music", path: "/music" },
                { label: "Genealogy", path: "/genealogy" },
                { label: "The Dispatch", path: "/newsletter" },
                { label: "Press", path: "/press" },
                { label: "Contact", path: "/contact" },
              ].map(({ label, path }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="text-[#F5F0E8]/60 hover:text-[#C5A059] text-sm transition-colors duration-200"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-serif text-[#C5A059] font-semibold mb-4 text-sm uppercase tracking-widest">
              Connect
            </h4>
            <div className="space-y-3">
              <a href="/contact" className="flex items-center gap-3 text-[#F5F0E8]/60 hover:text-[#C5A059] text-sm transition-colors duration-200">
                <Mail size={14} />
                Send a Message
              </a>
              <a href="/ad0k" className="flex items-center gap-3 text-[#F5F0E8]/60 hover:text-[#C5A059] text-sm transition-colors duration-200">
                <Radio size={14} />
                ADØK on the Air
              </a>
              <a href="/books" className="flex items-center gap-3 text-[#F5F0E8]/60 hover:text-[#C5A059] text-sm transition-colors duration-200">
                <BookOpen size={14} />
                Academic Publications
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F5F0E8]/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#F5F0E8]/40 text-xs">
            &copy; {new Date().getFullYear()} Donald Inbody. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/admin" className="text-[#F5F0E8]/30 hover:text-[#F5F0E8]/60 text-xs transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
